"use strict";
(() => {
  // .src/js/bk-media.js
  var VideoProof = class extends HTMLElement {
    constructor() {
      super();
      this.content = this.querySelector(".video-proof-content");
      this.video = this.querySelector(".video-proof-content video");
      this.html = document.querySelector("html");
      this.visible = false;
      this.eventListener();
    }
    handlePopoverToggle(e) {
      if (e.newState === "open") {
        this.video.play();
        this.html.classList.add("overflow-hidden");
      } else {
        this.video.pause();
        this.html.classList.remove("overflow-hidden");
      }
    }
    eventListener() {
      this.content.addEventListener("toggle", this.handlePopoverToggle.bind(this));
    }
  };
  customElements.define("video-proof", VideoProof);
})();
